import React, { Fragment } from 'react';
import Icon from 'Components/Icon';
import Link from 'Components/Link';
import styles from './styles.scss';
import {
  emailTracking,
  telephoneTracking,
  addressTracking,
  whatsappTracking,
} from 'Utils/trackingAttributes';

export default class DealerContact extends React.Component {
  render() {
    const { branch } = this.props;
    const { address, whatsappWidget } = branch;
    const phone = branch.phone ? branch.phone.replace(/[^\d+]/g, '') : null;
    const addressData = address || {
      city: '',
      houseNumber: '',
      postalCode: '',
      street: '',
    };
    const destination = `${branch.name},${addressData.street},${addressData.postalCode}`
      .replace(/&/g, '%26')
      .replace(/\s+/g, '%20');
    const url = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;

    return (
      <div className={styles.address__item}>
        <div className={styles.contact}>
          {address && (
            <Fragment>
              <h4 className={styles.contact__header}>Adresse</h4>
              <div className={styles.contact__location}>
                <Icon name="marker" className={styles.icon} inline={false} />

                <address className={styles.contact__addressWrapper}>
                  <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    e2e={'address'}
                    to={url}
                    {...addressTracking('Dealer Contact Dropdown')}
                  >
                    <span className="sr-only">Route zur Adresse planen: </span>
                    <span className={styles.contact__address}>
                      {addressData.street} {addressData.houseNumber}
                      <br />
                      {addressData.postalCode} {addressData.city}
                    </span>
                    <span
                      className={styles.contact__schedule}
                      data-e2e={'route'}
                      aria-hidden="true"
                    >
                      Route planen
                    </span>
                  </Link>
                </address>
              </div>
            </Fragment>
          )}

          {phone && (
            <Fragment>
              <h4 className={styles.contact__header}>Kontakt</h4>
              <address className={styles.contact__phone}>
                <Icon name="phone-small" className={styles.icon} inline={false} />
                <Link
                  to={`tel:${phone}`}
                  {...telephoneTracking('Dealer Contact Dropdown')}
                  e2e={'phone'}
                  label={branch.phone}
                />
              </address>
            </Fragment>
          )}

          {branch.email && (
            <address className={styles.contact__email}>
              <Icon name="mail-small" className={styles.icon} inline={false} />

              <Link
                to={`mailto:${branch.email}`}
                {...emailTracking('Dealer Contact Dropdown')}
                e2e={'email'}
                label={branch.email}
              />
            </address>
          )}

          {whatsappWidget && whatsappWidget.whatsappUrl && (
            <address className={styles.contact__whatsapp} style={{ display: 'flex' }}>
              <img
                role="presentation"
                className={styles.icon}
                src={`${process.env.ASSET_ENV_HOST}/assets/img/icon_whatsapp_dark_blue.svg`}
              />
              <Link
                to={whatsappWidget.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                {...whatsappTracking('Dealer Contact Dropdown')}
                e2e={'whatsapp'}
                label="WhatsApp Chat starten"
              />
            </address>
          )}
        </div>
      </div>
    );
  }
}
